const submitLabel = 'Save Changes'
export default submitLabel;